<app-radio-input-group #childCriteriaComponent [indication]="criteriaIndication" [labelName]="'Criteria'" [controlName]="'criteria'" 
 [controlDisplayName]="'Criteria'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedRadioControlSelectionChangedHandler($event)"></app-radio-input-group>
<br />
<app-limits-input #childLowerLimitsComponent [indication]="lowerLimitsIndication" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedTextControlSelectionChangedHandler($event)"></app-limits-input>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
